// import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Popup from 'Component/Popup/Popup.container';
import ProductCard from 'Component/ProductCard';

import './YBProductoAsociado.style';

/** @namespace Elganso/Component/YBProductoAsociado/Component */
export class YBProductoAsociado extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        const {
            sku,
            productoAsociadoFinal,
            closePopupProductoAsociado
        } = this.props;

        if (productoAsociadoFinal) {
            const id = `producto-asociado-${sku}`;
            return (
                <Popup
                  id={ id }
                  clickOutside={ false }
                  mix={ { block: 'YBProductoAsociado', elem: 'Popup' } }
                >
                    <div className="content">
                        <div className="item-product">
                            <p className="texto-producto-asociado">
                                { __('¿Puede que también necesites?...') }
                            </p>
                            <ProductCard
                              key={ id }
                              product={ productoAsociadoFinal }
                              mix={ {
                                  block: 'ProductoAsociado',
                                  elem: 'ProductCard'
                              } }
                              hideWishlistButton
                            />
                             <button
                               aria-label="Cerrar"
                               className="PopupProductoAsociado-CloseBtn"
                               onClick={ closePopupProductoAsociado }
                             >
                                    { __('No, gracias.') }
                             </button>
                        </div>
                    </div>
                </Popup>
            );
        }

        return null;
    }
}

export default YBProductoAsociado;
